import {SvgIcon, SvgIconProps} from "@mui/material";

export const CircleTableIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="6" fill="none" stroke="currentColor"
                strokeWidth="1.5"/>
        <circle cx="12" cy="3" r="2" fill="currentColor"/>
        <circle cx="19" cy="8" r="2" fill="currentColor"/>
        <circle cx="19" cy="16" r="2" fill="currentColor"/>
        <circle cx="12" cy="21" r="2" fill="currentColor"/>
        <circle cx="5" cy="16" r="2" fill="currentColor"/>
        <circle cx="5" cy="8" r="2" fill="currentColor"/>
    </SvgIcon>
);